import { InputLabel, FormControl, Select, MenuItem } from '@mui/material'
import { isEmpty, isEqual } from 'lodash'
import { useState, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { MAP_GPS_SOURCE_TYPE } from './helper/constants'
import GeoMapForm from './geotab-map/GeoMapForm'
import { DriverMapForm } from './driver-map/DriverMapForm'

const sourceTypeOption = Object.values(MAP_GPS_SOURCE_TYPE).map((value) => {
	const option = { label: value, value: value }
	if (value === MAP_GPS_SOURCE_TYPE.GEOTAB_ADDINS) {
		option.label = 'Geotab'
	}
	return option
})

const DEFAULT_REPEAT_RELOAD_MAP_SECONDS = 10 // Default value for repeat reload map seconds

const MapForm = ({
	vehicleLoading,
	filterData,
	vehicleList,
	linkedFields,
	dashboardKeyList,
	onFilterDataChange,
}) => {
	const { environment } = useSelector((state) => state)
	const { t } = useTranslation('common')

	const [gpsSourceType, setGPSSourceType] = useState('')

	function handleGPSSourceChange(e) {
		const newGPSSource = e.target.value
		onFilterDataChange('gpsSource', newGPSSource)
	}

	const availableGPSSource = useMemo(() => {
		const hasDriverTech = environment?.account.driverTechnologies || false
		const hasGeotab = environment?.account.geotab || false
		return sourceTypeOption.filter((item) => {
			if (item.value === MAP_GPS_SOURCE_TYPE.DRIVER_TECHNOLOGIES && !hasDriverTech) {
				return false
			}
			if (item.value === MAP_GPS_SOURCE_TYPE.GEOTAB_ADDINS && !hasGeotab) {
				return false
			}
			return true
		})
	}, [environment?.account])

	useEffect(() => {
		// support old data
		if (isEmpty(availableGPSSource)) return
		if (isEmpty(filterData.gpsSource)) {
			if (availableGPSSource.includes(MAP_GPS_SOURCE_TYPE.GEOTAB_ADDINS)) {
				onFilterDataChange('gpsSource', MAP_GPS_SOURCE_TYPE.GEOTAB_ADDINS)
				return
			} else {
				const firstItem = availableGPSSource[0]
				onFilterDataChange('gpsSource', firstItem.value)
				return
			}
		}
	}, [availableGPSSource])

	useEffect(() => {
		if (isEmpty(filterData.gpsSource) || isEqual(gpsSourceType, filterData.gpsSource)) return

		setGPSSourceType(filterData.gpsSource)
	}, [filterData.gpsSource])

	useEffect(() => {
		if (!isEmpty(filterData.repeatReloadMapSeconds)) return

		onFilterDataChange('repeatReloadMapSeconds', DEFAULT_REPEAT_RELOAD_MAP_SECONDS)
	}, [filterData.repeatReloadMapSeconds])

	return (
		<>
			<FormControl variant="outlined" size="small" fullWidth>
				<InputLabel id="gps-source-label">GPS source</InputLabel>
				<Select
					id="gps-source-select"
					labelId={'gps-source-label'}
					value={gpsSourceType}
					label={'GPS source'}
					onChange={handleGPSSourceChange}
				>
					{availableGPSSource.map((item) => (
						<MenuItem value={item.value}>{item.label}</MenuItem>
					))}
				</Select>
			</FormControl>
			{!isEmpty(availableGPSSource) &&
				filterData.gpsSource === MAP_GPS_SOURCE_TYPE.GEOTAB_ADDINS && (
					<GeoMapForm
						vehicleList={vehicleList}
						vehicleLoading={vehicleLoading}
						filterData={filterData}
						linkedFields={linkedFields}
						dashboardKeyList={dashboardKeyList}
						onFilterDataChange={(id, value) => {
							onFilterDataChange(id, value)
						}}
					/>
				)}
			{!isEmpty(availableGPSSource) &&
				filterData.gpsSource === MAP_GPS_SOURCE_TYPE.DRIVER_TECHNOLOGIES && (
					<DriverMapForm
						filterData={filterData}
						linkedFields={linkedFields}
						dashboardKeyList={dashboardKeyList}
						onFilterDataChange={(id, value) => {
							onFilterDataChange(id, value)
						}}
					/>
				)}
		</>
	)
}

export default MapForm
